<div class="grid grid-cols-1 xl:grid-cols-3 pb-2 items-start px-6 gap-4">
    <!-- left side -->
    <div class="bg-white rounded-lg mt-2 p-4 xl:col-span-1">
        <div class="overflow-x-auto">
            <div class="flex items-center pb-4 bg-white w-full">
                <div class="flex items-center space-x-2">

                    <div class="relative sm:w-auto">
                        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <svg class="w-4 h-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg>
                        </div>
                        <input type="search" [(ngModel)]="searchParams().pp_number" (search)="fetchPOData()"
                            class="focus:ring-gray-100 focus:border-gray-300 p-2.5 block w-full pl-10 pr-3 py-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                            placeholder="PP Number">
                        </div>
                        <div class="flex-shrink-0">
                        <button (click)="fetchPOData()" type="submit"
                            class="button-blue inline-flex items-center whitespace-nowrap">
                            <span class="hidden sm:inline">Search</span>
                        </button>
                        </div>
                    </div>
                    <div class="ml-auto flex-shrink-0">
                        <button type="button" class="button-blue inline-flex items-center whitespace-nowrap"
                        (click)="openFileUploadModal()">
                        Upload File
                        </button>
                    </div>
                </div>
            <div class="overflow-x-auto">
                <div class="table-wrapper overflow-x-auto">
                    <table class="table">
                        <thead class="table-thead">
                            <tr>
                                <th scope="col" class="px-6 py-3">Job Number</th>
                                <th scope="col" class="px-6 py-3">Customer</th>
                                <th scope="col" class="px-6 py-3">Job Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (jobs of jobCardFindDTOS(); track jobs) {
                                <tr class="bg-white border-b hover:bg-blue-100 cursor-pointer" (click)="getJobDetails(jobs.jobCardId)" (click)="onJobRowClick(jobs.ppNo)">
                                    <td class="px-6 py-2 text-sm">{{ jobs.ppNo | uppercase }}
                                    <td class="px-6 py-2 text-sm">{{ jobs.customer || '-' | uppercase }}
                                    <td class="px-6 py-2 text-sm"> {{ jobs.description }}</td>
                                </tr>
                            } @empty {
                                <tr>
                                    <td colspan="12" class="px-6 py-10">
                                        <div class="flex flex-col items-center justify-center text-center">
                                            @if (!hasSearched()) {
                                                <p class="text-xl font-semibold text-gray-700 mb-2">Search Job Number</p>
                                                <p class="text-gray-500">Please enter a PP number and search to get data.</p>
                                            } @else {
                                                <p class="text-xl font-semibold text-gray-700 mb-2">No Jobs Found</p>
                                                <p class="text-gray-500">We couldn't find any pending jobs that match your search criteria.</p>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    
                    
                    <app-pagination [totalItems]="$$totalItems()" [itemsPerPage]="$$itemsPerPage()"
                                    (pageChanged)="onPageChange($event)"></app-pagination>
        
                </div>
            </div>
        </div>
    </div>

    <!-- right side -->
    <div class="bg-white rounded-lg mt-2 p-4 xl:col-span-2">
        <div class="overflow-x-auto px-2">
            @if($$showFileUploadModal()){
                <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                    <span>Create Job Operation {{ jobCardGetDTOS()[0].jobNumber }}</span>
                </h3>
                <div class="flex flex-col bg-gray-100 border px-6 pt-2 mt-2 rounded-lg pb-4">
                    <span class="mt-2 w-full text-sm font-semibold text-gray-700">{{ jobCardGetDTOS()[0].customer }}</span>
                    <span class="mt-2 w-full text-sm font-semibold text-gray-700">{{ jobCardGetDTOS()[0].jobDescription }}</span>
                    <ng-container *ngIf="!jobCardGetDTOS()[0].productType?.toLowerCase()?.includes('flexo')">
                        <span class="mt-2 w-full text-sm font-semibold text-gray-700">Number of Cut Sheets - {{ jobCardGetDTOS()[0].cutSheets }}</span>
                        <span class="mt-2 w-full text-sm font-semibold text-gray-700">Number Of Impressions - {{ jobCardGetDTOS()[0].numberOfImpressions | number }}</span>
                        <span class="mt-2 w-full text-sm font-semibold text-gray-700">Number of Cuts - {{ jobCardGetDTOS()[0].numberOfCuts }}</span>
                    </ng-container>
                    <span class="mt-2 w-full text-sm font-semibold text-gray-700">Job Quantity - {{ jobCardGetDTOS()[0].jobQuantity | number }}</span>
                    <span class="mt-2 w-full text-sm font-semibold text-gray-700">Job Ups - {{ jobCardGetDTOS()[0].numberOfUps }}</span>
                    <span class="mt-2 w-full text-sm font-semibold text-gray-700">Job Colors - {{ jobCardGetDTOS()[0].numberOfColors }}</span>
                    <span class="mt-2 w-full text-sm font-semibold text-gray-700">Job Request Date - {{ jobCardGetDTOS()[0].requestDate }}</span>
                    <ng-container *ngIf="jobCardGetDTOS()[0].productType?.toLowerCase()?.includes('flexo')">
                        <span class="mt-2 w-full text-sm font-semibold text-gray-700">Reel Length - {{ jobCardGetDTOS()[0].reelLength }} m</span>
                        <span class="mt-2 w-full text-sm font-semibold text-gray-700">Reel Width - {{ jobCardGetDTOS()[0].reelWidth }} mm</span>
                        <span class="mt-2 w-full text-sm font-semibold text-gray-700">Slit Width - {{ jobCardGetDTOS()[0].slitWidth }}</span>
                    </ng-container>
                </div>
                <div>
                    <div class="flex justify-between p-2 rounded-t flex flex-col mb-4 py-4 rounded-lg">
    
                        <div class="flex flex-col space-y-3 mb-2 w-full">
                            <div class="w-full">
                                <div
                                        *ngFor="let item of finishings(); let i = index"
                                        class="w-full"
                                        draggable="true"
                                        (dragstart)="onDragStart(i)"
                                        (dragover)="onDragOver($event, i)"
                                        (drop)="onDrop(i)"
                                        (dragEnd)="onDragEnd()"
                                >
                                    <div class="flex flex-col w-full space-y-2">
                                        <div class="flex flex-row gap-4 items-center justify-center w-full space-y-4">
                                            <span class="text-sm font-semibold text-gray-700 flex-1 gap-2 truncate">
                                                {{ i + 1 }}. {{ item.name | uppercase }}{{ item.workOrderId ? ' - ' + item.workOrderId : '' }}
                                            </span>

                                            <label class="flex items-center gap-1.5 cursor-pointer text-xs font-semibold text-gray-700 whitespace-nowrap">
                                                <input type="checkbox" [(ngModel)]="item.isFinal" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
                                                <span>Is Last</span>
                                            </label>


                                            <select id="machine" class="textField flex-1" [(ngModel)]="item.machineId" (ngModelChange)="onMachineSelect($event, i)">
                                                <option [ngValue]="null" hidden disabled selected>Choose a Machine</option>
                                                @for (machine of item.availableMachines; track machine) {
                                                    <option [ngValue]="machine.machineId">{{ machine.machineName | titlecase }}</option>
                                                }
                                            </select>
                                            <input type="datetime-local" [min]="minDateTime" class="textField flex-1" [(ngModel)]="item.endDate" (ngModelChange)="onEndDateChange($event, i)" />
                                            <input type="number" min="0" step="0.01" class="textField flex-1" [(ngModel)]="item.estimateTime" (ngModelChange)="onEstimateTimeChange($event, i)" placeholder="Estimate Time (hours)" />
                                            <input type="number" min="0" step="0.01" class="textField flex-1" [(ngModel)]="item.operationQuantity" placeholder="Quantity" />
                                            <input type="text" class="textField flex-1" [(ngModel)]="item.remarks" placeholder="Remarks"name="remarks" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="rounded-lg mt-4 p-4 bg-blue-50 border border-blue-200 text-blue-600 text-sm mb-6 w-full text-center">
                            You can change the sequence by dragging and dropping the items into your desired order.
                        </div>
                        <div class="flex flex-row w-full">
                            <h3 class="text-sm font-semibold mb-3 text-gray-700 flex items-center gap-2 w-full">
                                Select Deliver Date
                            </h3>
                            <div class="flex flex-col w-full mb-4">
                                <input
                                        type="date"
                                        class="textField"
                                        [(ngModel)]="selectedDeliverDate"
                                        #deliverDate="ngModel"
                                        [min]="minDate"
                                        required
                                />
                                <div *ngIf="deliverDate.invalid && deliverDate.touched"
                                     class="text-sm text-red-500 mt-1">
                                    Delivery date is required.
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="flex justify-end space-x-3">
                                <button
                                        type="button"
                                        class="button-blue"
                                        (click)="saveMachineDetails();"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div *ngIf="saveMessage" class="px-4 self-center pb-4">
                        <div
                                [ngClass]="{'text-success bg-green-50 border-green-200 text-green-600': saveMessage.startsWith('Job operation saved'),
                                            'text-danger bg-red-50 border-red-200 text-red-600': saveMessage.startsWith('Error')}"
                                class="rounded-lg p-4 border-green-200 text-sm mt-1 text-center ">
                            {{ saveMessage }}
                        </div>
                    </div>
                </div>
            }
             @else {
                <div class="flex items-center justify-center h-96">
                    <div class="text-center">
                        <p class="text-xl font-semibold text-gray-700">No Job Selected</p>
                        <p class="text-gray-500">Please select a job to view and manage its operations.</p>
                    </div>
                </div>
            }            
            
        </div>
    </div>
</div>

 @if (modal.$$showFileUploadModal()){
        <div id="operation-modal" tabindex="-1" aria-hidden="true" class=" fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
            <div class="relative p-4 w-full max-w-5xl mx-auto bg-white rounded-lg shadow-lg">
                <div class="relative">
                    <div class="flex items-center justify-between p-4 border-b rounded-t">
                        <h3 class="text-lg font-semibold text-gray-900 flex items-center">
                            <span>Job Card Upload</span>
                            <span class="status-badge ml-4"></span>
                        </h3>
                        <button type="button" (click)="modal.$$showFileUploadModal.set(false)"
                                class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                                data-modal-toggle="crud-modal">
                            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                                 viewBox="0 0 14 14">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>
                            <span class="sr-only">Close modal</span>
                        </button>
                    </div>
                    <div class="pt-4">
                        <div class="p-4">
                            <div class="flex flex-col items-center justify-center w-full">
                                <label
                                  for="dropzone-file"
                                  class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:bg-gray-700 dark:border-gray-600 focus-within:ring-2 focus-within:ring-blue-500 focus-within:ring-offset-2"
                                  role="button"
                                  aria-describedby="file-upload-instructions"
                                >
                                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                                    <svg
                                      class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 20 16"
                                    >
                                      <path
                                        d="M13 13h3a3 3 0 000-6h-.025A5.56 5.56 0 0016 6.5 5.5 5.5 0 005.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 000 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                      />
                                    </svg>
                                    <p id="file-upload-instructions" class="mb-2 text-xl text-gray-500">
                                      <span class="font-semibold">Click to upload</span> or drag and drop
                                    </p>
                                    <p class="text-sm text-gray-500">
                                      Only Excel (.xlsx, .xls) and CSV (.csv) files are allowed
                                    </p>
                                  </div>
                                  <input
                                    id="dropzone-file"
                                    type="file"
                                    class="hidden"
                                    (change)="onFileSelected($event)"
                                    accept=".xlsx,.xls,.csv"
                                  />
                                </label>
                              </div>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }